export var globalVal= {isLoggedOut:false};

export const INPUT_FONT_SIZE = '16px';